import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { invoiceService } from '../../services/InvoiceService';
import { Button } from '../../components';

interface EmailInvoiceFormProps {
    invoiceId: number;
    onSave: () => void;
    onCancel: () => void;
}

const EmailInvoiceForm = (props: EmailInvoiceFormProps) => {
    const schema = yup
        .object({
            altEmail: yup.string().notRequired().nullable(),
        })
        .defined();

    const { handleSubmit, control } = useForm({
        resolver: yupResolver(schema as any),
    });

    const onSubmit = (formData) => {
        const toastId = toast.info('Emailing Invoice...');

        invoiceService
            .emailInvoices([props.invoiceId], formData.altEmail ? formData.altEmail : null)
            .then(() => {
                toast.update(toastId, {
                    type: 'success',
                    render: 'Invoice emailed successfuly',
                });
                props.onSave();
            })
            .catch((e) => {
                if (e.error) {
                    toast.update(toastId, {
                        type: 'error',
                        render: 'Error emailing Invoice',
                    });
                } else {
                    toast.update(toastId, {
                        type: 'error',
                        render: 'Error emailing Invoice',
                    });
                }
            });
    };
    return (
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
                <Label for="altEmail">Alternative Email</Label>
                <Controller
                    name="altEmail"
                    control={control}
                    render={({ field }) => <Input {...field} value={field.value ?? ''} />}
                />
            </FormGroup>
            <div>
                <Button type="button" color={'link'} onClick={props.onCancel}>
                    Cancel
                </Button>
                <Button type="submit">Send</Button>
            </div>
        </Form>
    );
};

export default EmailInvoiceForm;
